export default __webpack_public_path__ + "static/media/theme1net.11181951.png";